module.exports = __webpack_public_path__ + "img/jd.id@2x.81de04f2.png";